import * as React from 'react';
import { compose, withProps, withHandlers, withState } from 'recompose';
import { reduxForm, FormSection, change } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get, isEmpty } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { connect } from 'react-redux';

import * as T from '@modules/events/_eventsTypes';
import {
  identificationsGridColumns,
  classificationsColumns,
  eventsFormMultipleCitizenshipGridColumns
} from '@modules/events/_eventsColumns';
import { EventsFormParticipantsParticipantsIdentificationsForm } from '@modules/events/EventsFormParticipantsParticipantsIdentificationsForm';
import { EventsFormParticipantsParticipantsClassificationTypeForm } from '@modules/events/EventsFormParticipantsParticipantsClassificationTypeForm';

import { Person } from '@components/person';
import {
  InlineGridField,
  InlineGrid,
  AutoComplete,
  AutoCompleteField,
  RemoteAutoComplete,
  RemoteAutoCompleteField,
  RemoteChipInputField,
  RemoteChipInput
} from '@components/form';
import { participantsTypeEnum } from '@modules/events/_eventsEnums';
import Address, { AddressField } from '@components/form/Address/Address';
import { required } from '../../utils/validators';
import { putParticipant } from './_eventsActions';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';
import CrrSection from '@components/person/CrrForm';

const mapStateToProps = state => ({
  participants: get(state, 'form.module-events.values.participants', [])
});

const mapDispatchToProps = dispatch => ({
  setParticipants: participants => dispatch(change('module-events', 'participants', participants))
});

const enhance = compose<T.EmployeesFormProps, T.Outter & T.EmployeesFormProps>(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('loading', 'setLoading', false),
  withNotifications({ putParticipant }),
  withProps(({ initialValues }) => ({
    initialValues: {
      person: {
        identifications: [],
        type: 'NATURAL'
      },
      classificationType: [],
      ...initialValues
    }
  })),
  withHandlers({
    onSubmit: ({
      putParticipantNotify,
      initialValues,
      setLoading,
      participants,
      setParticipants,
      closeItem
    }) => async formData => {
      setLoading(true);
      let participantNew = {};
      if (initialValues) {
        const { photoTmp, ...eventParticipant } = formData;
        const ep = { ...eventParticipant, classificationType: eventParticipant.classificationType.map(v => v.id) };
        participantNew = await putParticipantNotify({ eventParticipant: ep, photoTmp }, initialValues.id);
      } else {
        const { photoTmp, ...eventParticipant } = formData;
        const ep = { ...eventParticipant, classificationType: eventParticipant.classificationType.map(v => v.id) };
        participantNew = await putParticipantNotify({ eventParticipant: ep, photoTmp });
      }
      if (!isEmpty(participantNew)) {
        setParticipants([...participants.filter(p => p.id !== get(participantNew, 'id')), participantNew]);
      }
      setLoading(false);
      closeItem();
    }
  }),
  reduxForm({
    form: 'module-events-participants'
  })
);
const View: React.SFC<any> = ({ handleSubmit, closeItem, form, onSubmit, loading }) => (
  <div>
    {loading && <Loader />}
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={6} xl={6} className="with-right-divider">
                <Row>
                  <Col md={12}>
                    <h4>Jméno</h4>
                  </Col>
                </Row>
                <FormSection name="person">
                  <Person
                    withMaidenName={true}
                    withPhone={true}
                    withNote={true}
                    withPhoto={true}
                    showCompanyInputs={true}
                    form={form}
                    formName={'person.'}
                  />
                </FormSection>
              </Col>
              <Col md={6} xl={6}>
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={12}>
                        <h4>Typ</h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <AutoCompleteField
                          component={AutoComplete}
                          id={'type'}
                          name={'type'}
                          label={'Typ *'}
                          items={participantsTypeEnum}
                          fullWidth={true}
                          labelFunction={o => get(o, 'label')}
                          valueFunction={o => get(o, 'id')}
                          validate={[required]}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={12}>
                        <h4>Narození</h4>
                      </Col>
                    </Row>
                    <AddressField component={Address} name={'person.birthAddress'} />

                    <Row>
                      <Col md={12}>
                        <RemoteAutoCompleteField
                          component={RemoteAutoComplete}
                          label="Občanství"
                          name="person.citizenship"
                          url="/metropolis/api/common/countries"
                          filterActive={true}
                          labelFunction={o => get(o, 'name')}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <h4>Vícenásobné občanství</h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <RemoteChipInputField
                          component={RemoteChipInput}
                          id="person.multipleCitizenship"
                          name="person.multipleCitizenship"
                          label=""
                          url="/metropolis/api/common/countries"
                          filterActive={true}
                          labelFunction={o => get(o, 'name')}
                          fullWidth={true}
                        />
                        <InlineGridField
                          component={InlineGrid}
                          name="person.multipleCitizenship"
                          columns={eventsFormMultipleCitizenshipGridColumns}
                          showCheckboxes={false}
                          deleting={false}
                          adding={false}
                          editing={false}
                          filtering={false}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <h4>Kontaktní adresa</h4>
                      </Col>
                    </Row>
                    <AddressField component={Address} name={'person.contactAddress'} />
                    <Row>
                      <Col md={12}>
                        <h4>Bydliště</h4>
                      </Col>
                    </Row>
                    <AddressField component={Address} name={'person.address'} />
                    <FormSection name="person">
                      <CrrSection form={form} formName="person." />
                    </FormSection>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col className="grid-system-margin" />
            </Row>
            <Divider />
            <Row>
              <Col className="grid-system-margin" />
            </Row>

            <Row>
              <Col md={12}>
                <h4>Doklady totožnosti</h4>
              </Col>
            </Row>
            <Row className="without-min-width">
              <Col md={12}>
                <InlineGridField
                  component={InlineGrid}
                  name="person.identifications"
                  Form={EventsFormParticipantsParticipantsIdentificationsForm}
                  columns={identificationsGridColumns}
                  showCheckboxes={true}
                  deleting={true}
                  filtering={false}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4>Klasifikace účastníka</h4>
              </Col>
            </Row>
            <Row className="without-min-width">
              <Col md={12}>
                <InlineGridField
                  component={InlineGrid}
                  name="classificationType"
                  Form={EventsFormParticipantsParticipantsClassificationTypeForm}
                  columns={classificationsColumns}
                  showCheckboxes={true}
                  deleting={true}
                  filtering={false}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button
        type="submit"
        label="Uložit a zavřít"
        onClick={handleSubmit(onSubmit)}
        primary={true}
        style={{ margin: '16px 0 16px 16px' }}
      />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EventsFormParticipantsParticipantsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormParticipantsParticipantsForm.tsx